import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

export default class extends Controller {
  static targets = ["tableBody", "template", "uploadRow"];
  static values = {
    uploadUrl: { type: String },
  };

  #queue = [];

  handleFileDrop({ detail }) {
    const files = detail.files;
    if (!files?.length) return;

    for (const file of files) {
      this.#queue.push(file);
      this.#insertNewRow();
    }
  }

  uploadRowTargetConnected(uploadRow) {
    const file = this.#queue.shift();
    if (!file) return;

    const rowId = this.#generateRowId();
    const cell = uploadRow.querySelector(".filename");
    uploadRow.id = rowId;
    cell.id = `${rowId}_filename`;
    cell.textContent = file.name;

    this.#submitFile(file, rowId);
  }

  #generateRowId() {
    return Math.random().toString(36).slice(2);
  }

  #insertNewRow() {
    const newRow = document.importNode(this.templateTarget.content, true);
    this.tableBodyTarget.prepend(newRow);
    return newRow;
  }

  async #submitFile(file, rowId) {
    const body = new FormData();
    body.append("file", file);

    await post(this.uploadUrlValue, {
      query: { dom_id: rowId },
      body,
      responseKind: "turbo-stream",
    });
  }
}
